import { render, staticRenderFns } from "./edc-form-queries.vue?vue&type=template&id=081cbe0b&"
import script from "./edc-form-queries.vue?vue&type=script&lang=js&"
export * from "./edc-form-queries.vue?vue&type=script&lang=js&"
import style0 from "./edc-form-queries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edc-form-queries.vue"
export default component.exports